import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'

export const CustomerSupport = (props: LevelProps) => {
  return <LevelPage {...props} imgScale={0.45} textWidth="70%" cards={LEVEL_CARDS.L3.CUSTOMER_SUPPORT} />
}
